export const canEditDimensionesPublicacion = (publicacion, dimensionesPrevias) => {
    const verifyDimensiones = ["alto", "ancho", "peso", "profundidad"];
    let canEditDimensiones = false;
    const normalizeDimensionValue = (value) => {
        if (value === "" || value == null) return value;

        const numericValue = Number(value);
        return Number.isNaN(numericValue) ? value : numericValue;
    };

    if (publicacion.dimensiones.length === dimensionesPrevias.length) {
        for (let i = 0; i < publicacion.dimensiones.length; i++) {
            const compareResults = verifyDimensiones.map((item) => {
                const valorActual = publicacion.dimensiones[i][item];
                const valorInicial = dimensionesPrevias[i][item];
                const valorActualNormalizado = normalizeDimensionValue(valorActual);
                const valorInicialNormalizado = normalizeDimensionValue(valorInicial);
                const changed = valorActualNormalizado !== valorInicialNormalizado;

                return changed;
            });

            canEditDimensiones = compareResults.some(Boolean);
            if (canEditDimensiones) break;
        }
    } else {
        canEditDimensiones = true;
    }

    return canEditDimensiones;
}